import { toSafeWhitespaceString as toSafeString } from '@shared/utils';
import resolveMainThreadHeaderRouteContext from '@/lib/routes/resolveMainThreadHeaderRouteContext.js';
import normalizeThreadType from '@/lib/threads/normalizeThreadType.js';
import { pathname, activeAutomationsPane } from '@/redux/selectors/uiSelectors.js';
import { isDraftThreadActive } from '@/redux/selectors/pieveSelectors/sidebarProjectSelectors.js';
import { activeThreadId } from '@/redux/selectors/pieveSelectors/activeThreadIdSelector.js';
import { routeThreadId } from '@/redux/selectors/pieveSelectors/routeSelectors.js';
import { currentAutomationScheduleRunThreadId } from '@/redux/selectors/pieveSelectors/automationScheduleSelectors.js';
import { currentAutomationTriggerRunThreadId } from '@/redux/selectors/pieveSelectors/automationTriggerSelectors.js';
import { threadType } from '@/redux/selectors/pieveSelectors/threadCoreSelectors.js';

export const automationBreadcrumbType = (state) => {
  const currentPathname = pathname(state);
  const currentActiveAutomationsPane = activeAutomationsPane(state);
  const currentActiveThreadId = activeThreadId(state);
  const currentRouteThreadId = isDraftThreadActive(state) ? '' : toSafeString(routeThreadId(state));
  const workspaceThreadId = toSafeString(currentRouteThreadId || currentActiveThreadId) || null;
  const activeThreadTypeForWorkspace = normalizeThreadType(threadType(state, workspaceThreadId), '');
  const currentActiveThreadType = normalizeThreadType(threadType(state, currentActiveThreadId), 'default');

  const routeContext = resolveMainThreadHeaderRouteContext({ activeAutomationsPane: currentActiveAutomationsPane, pathname: currentPathname });
  const { automationsRouteContext, isAutomationsEditMode, isAutomationsWorkflowsView, isSchedulesView, isThreadScreenView, isTriggersView } = routeContext;

  const isScheduleThreadMode = activeThreadTypeForWorkspace === 'schedule' || activeThreadTypeForWorkspace === 'schedule_run';
  const isTriggerThreadMode = activeThreadTypeForWorkspace === 'trigger' || activeThreadTypeForWorkspace === 'trigger_run';
  const isWorkflowAuthoringThreadView = currentActiveThreadType === 'workflow';
  const isScheduleRunHeaderContext = Boolean(currentAutomationScheduleRunThreadId(state) || activeThreadTypeForWorkspace === 'schedule_run');
  const isTriggerRunHeaderContext = Boolean(currentAutomationTriggerRunThreadId(state) || activeThreadTypeForWorkspace === 'trigger_run');

  if ((isSchedulesView || (isThreadScreenView && isScheduleThreadMode)) && !isScheduleRunHeaderContext) {
    return 'schedules';
  }

  if ((isTriggersView || (isThreadScreenView && isTriggerThreadMode)) && !isTriggerRunHeaderContext) {
    return 'triggers';
  }

  if (isWorkflowAuthoringThreadView || isAutomationsWorkflowsView) {
    return 'workflows';
  }

  if (isAutomationsEditMode && automationsRouteContext?.type) {
    return automationsRouteContext.type;
  }

  return '';
};
